<template>
  <div class="inventory-reconciliation-details">
    <div class="row">
      <div class="sub-title">基本信息</div>
      <EnterExitWarehouseRegisterBaseInfo
        :id="inventoryReconciliationId"
        :baseInfoList="baseInfoList"
        :baseInfoObj="baseInfoObj"
        :fromPage="'inventoryReconciliation'"
        :feeList="feeList"
        ></EnterExitWarehouseRegisterBaseInfo>
    </div>

    <div class="inventory-reconciliation-details-content">
      <div class="table-row">
        <div class="title-row">
          <div class="sub-table-title">进仓费用</div>
        </div>
        <div class="code-data">
          <div class="code-data-left">
            <div
              v-for="(item, index) in enterWarehouseCodeList" 
              :key="index"
              class="code-main"
              :class="item.code === activeEnterWarehouseCode?'code-main code-main-active':'code-main'"
            >
              <div :class="item.code === activeEnterWarehouseCode?'tips tips-active':'tips'" @click="onActiveEnterWarehouseCode(item)">
                <tool-tip v-bind="{ txtInfo: `进仓单：${item.code}` }">
                </tool-tip>
              </div>
            </div>
          </div>
          <div class="code-data-right">
            <div class="table">
              <el-table
                ref="enterWarehouseMultipleTable"
                :data="enterWarehouseTableData"
                style="width: 100%"
              >
                <el-table-column 
                  v-for="(item, index) in tableTitle"
                  :key="index"
                  show-overflow-tooltip
                  :prop="item.prop" 
                  :label="item.label">
                  <template slot-scope="scope">
                    <div v-if="item.prop === 'amount' && !scope.row.isMod">
                      {{ scope.row.amount }}
                    </div>
                    <el-input v-if="item.prop === 'amount' && scope.row.isMod" class="white w180" v-model="scope.row.amount" placeholder="请输入" @input="inputNums(scope.row, scope.row.amount)"></el-input>
                    <div v-if="item.prop !== 'amount'"
                    
                    style="
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;"
                    >{{scope.row[item.prop]}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" min-width="100" v-if="baseInfoObj.status === 10">
                  <template slot-scope="scope">
                    <el-button
                      v-if="scope.row.isMod"
                      class="btn-text"
                      type="text"
                      @click="saveEnterWarehouseCodeAmount(scope.row)"
                    >保存</el-button>
                    <el-button
                      v-if="scope.row.isMod"
                      class="btn-text"
                      type="text"
                      @click="cancelEnterWarehouseCodeAmount(scope.row)"
                    >取消</el-button>
                    <el-button
                      v-if="!scope.row.isMod"
                      :disabled="scope.row.isSplit"
                      class="btn-text"
                      type="text"
                      @click="modEnterWarehouseCodeAmount(scope.row)"
                    >编辑</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

      <div class="table-row">
        <div class="title-row">
          <div class="sub-table-title">出仓费用</div>
        </div>
        <div class="code-data">
          <div class="code-data-left">
            <div
              v-for="(item, index) in exitWarehouseCodeList" 
              :key="index"
              class="code-main exit-code-main"
              :class="item.code === activeExitWarehouseCode?'code-main code-main-active':'code-main'"
            >
              <img v-if="item.code === activeExitWarehouseCode" class="order-number" src="~assets/images/order-number-hign.png">
              <img v-else class="order-number" src="~assets/images/order-number.png">
              <div :class="item.code === activeExitWarehouseCode?'tips tips-active':'tips'" @click="onActiveExitWarehouseCode(item)">
                <tool-tip v-bind="{ txtInfo: `${item.code}` }">
                </tool-tip>
              </div>
            </div>
          </div>
          <div class="code-data-right">
            <div class="outbound-order">
              出仓单：{{ outboundOrderNo }}
            </div>
            <div class="table">
              <el-table
                ref="enterWarehouseMultipleTable"
                :data="exitWarehouseTableData"
                style="width: 100%"
              >
                <el-table-column 
                  v-for="(item, index) in tableTitle"
                  :key="index"
                  show-overflow-tooltip
                  :prop="item.prop" 
                  :label="item.label">
                  <template slot-scope="scope">
                    <div v-if="item.prop === 'amount' && !scope.row.isMod">
                      {{ scope.row.amount }}
                    </div>
                    <el-input v-if="item.prop === 'amount' && scope.row.isMod" class="white w180" v-model=" scope.row.amount" placeholder="请输入" @input="inputNums(scope.row, scope.row.amount)"></el-input>
                    <div v-if="item.prop !== 'amount'"
                    
                    style="
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;"
                    >{{scope.row[item.prop]}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" min-width="100" v-if="baseInfoObj.status === 10">
                  <template slot-scope="scope">
                    <el-button
                      v-if="scope.row.isMod"
                      class="btn-text"
                      type="text"
                      @click="saveExitWarehouseCodeAmount(scope.row)"
                    >保存</el-button>
                    <el-button
                      v-if="scope.row.isMod"
                      class="btn-text"
                      type="text"
                      @click="cancelExitWarehouseCodeAmount(scope.row)"
                    >取消</el-button>
                    <el-button
                      v-if="!scope.row.isMod"
                      :disabled="scope.row.isSplit"
                      class="btn-text"
                      type="text"
                      @click="modExitWarehouseCodeAmount(scope.row)"
                    >编辑</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

      <div class="table-row">
        <div class="title-row">
          <div class="sub-table-title">存储费用</div>
        </div>
        <div class="code-data">
          <div class="code-data-left">
            <div
              v-for="(item, index) in storageCodeList" 
              :key="index"
              class="code-main"
              :class="item.code === activeStorageCode?'code-main code-main-active':'code-main'"
            >
              <div :class="item.code === activeStorageCode?'tips tips-active':'tips'" @click="onActiveStorageCode(item)">
                <tool-tip v-bind="{ txtInfo: `进仓单：${item.code}` }">
                </tool-tip>
              </div>
            </div>
          </div>
          <div class="code-data-right">
            <div class="table">
              <el-table
                ref="enterWarehouseMultipleTable"
                :data="storageTableData"
                style="width: 100%"
              >
                <el-table-column 
                  v-for="(item, index) in storageTableTitle"
                  :key="index"
                  show-overflow-tooltip
                  :prop="item.prop" 
                  :width="item.width" 
                  :label="item.label">
                  <template slot-scope="scope">
                    <div v-if="item.prop === 'amount' && !scope.row.isMod">
                      {{ scope.row.amount }}
                    </div>
                    <el-input v-if="item.prop === 'amount' && scope.row.isMod" class="white w180" v-model="scope.row.amount" placeholder="请输入" @input="inputNums(scope.row, scope.row.amount)"></el-input>
                    <div v-if="item.prop !== 'amount'"
                    
                    style="
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;"
                    >{{scope.row[item.prop]}}</div>
                  </template>
                </el-table-column>
                
                <el-table-column label="操作" min-width="90">
                  <template slot-scope="scope">
                    <el-button
                      v-if="scope.row.isMod"
                      class="btn-text"
                      type="text"
                      @click="saveStorageWarehouseCodeAmount(scope.row)"
                    >保存</el-button>
                    <el-button
                      v-if="scope.row.isMod"
                      class="btn-text"
                      type="text"
                      @click="cancelStorageWarehouseCodeAmount(scope.row)"
                    >取消</el-button>
                    <el-button
                      v-if="!scope.row.isMod"
                      :disabled="scope.row.isSplit"
                      class="btn-text"
                      type="text"
                      @click="modStorageWarehouseCodeAmount(scope.row)"
                    >编辑</el-button>
                    <el-button
                      class="btn-text"
                      type="text"
                      @click="lookModRecords(scope.row)"
                    >编辑记录</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      
      <div class="footer">
        <el-button class="btn-white" @click="goBack">
          返回
        </el-button>
        <el-button v-if="baseInfoObj.status === 10" class="btn-red" @click="nullify">作废</el-button>
        <el-button :class="baseInfoObj.status === 10?'btn-white':'btn-blue'" @click="downExcel(inventoryReconciliationId)">
          导出
        </el-button>
        <el-button
          class="btn-white"
          v-if="baseInfoObj.status === 10"
          @click="autoSplit"
          >自动拆分</el-button
        >
        <el-button
          v-if="baseInfoObj.status === 10"
          class="btn-white"
          @click="handMovementSplit"
          >手动拆分</el-button
        >
      </div>
    </div>

    
    <!-- 自动/手动拆分预览 -->
    <AutoSplit
      :titleSplit="titleSplit"
      :previewList="previewList"
      :previewTitleList="previewTitleList"
      :previewDialog="previewDialog"
      @onSavePreview="onSavePreview"
      @onClosePreviewDialog="onClosePreviewDialog"
    ></AutoSplit>

    
    <!-- 手动拆分 -->
    <dialogTransfer
      v-if="generateInvoicedDialog"
      :title="title"
      :projectId="projectId"
      :projectName="projectName"
      :accountsType="accountsType"
      :billIds="billIds"
      :generateInvoicedDialog="generateInvoicedDialog"
      :subjectTableTitle="subjectTableTitle"
      :generateInvoicedWidth="'1146px'"
      @onCloseGenerateInvoiced="onCloseGenerateInvoiced"
      @onSaveGenerateInvoiced="onSaveGenerateInvoiced"
     ></dialogTransfer>

     
    <!-- 编辑记录 -->
    <el-dialog title="编辑记录" top="15vh" :visible.sync="historicalRecordsDialog" width="820px" :before-close="handleClose">
      <div class="border"></div>
      <div class="table">
        <el-table :data="historicalRecordsList" style="width: 100%" height="500px">
          <el-table-column
          v-for="(item, index) in historicalRecordsTitle"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :show-overflow-tooltip="item.showOverflowTooltip"
          :min-width="item.width">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { formatTimeToDate, getDecimal, modifyNetTitle } from 'common/js/util'
import toolTip from '@/components/base/toolTip.vue'
import AutoSplit from '@/components/base/inventory-reconciliation/auto-split.vue'
import dialogTransfer from '@/components/base/inventory-reconciliation/dialog-transfer.vue'
import CurrencyMinxins from "common/mixins/currency";
import InventoryReconciliation from "models/inventory-reconciliation";
import SplitMixins from 'common/mixins/inventory-reconciliation/split'
import InventoryReconciliationMixins from 'common/mixins/inventory-reconciliation/inventory-reconciliation'
import ExitInventoryReconciliationMixins from 'common/mixins/inventory-reconciliation/exit-inventory-reconciliation'
import EnterInventoryReconciliationMixins from 'common/mixins/inventory-reconciliation/enter-inventory-reconciliation'
import StorageInventoryReconciliationMixins from 'common/mixins/inventory-reconciliation/storage-inventory-reconciliation'
import EnterExitWarehouseRegisterBaseInfo from "components/base/enter-exit-warehouse-register/enter-exit-warehouse-register-base-info.vue"
export default {
  mixins: [EnterInventoryReconciliationMixins, ExitInventoryReconciliationMixins, SplitMixins,
  StorageInventoryReconciliationMixins, InventoryReconciliationMixins, CurrencyMinxins],
  components: {
    toolTip,
    AutoSplit,
    dialogTransfer,
    EnterExitWarehouseRegisterBaseInfo
  },

  data() {
    return {
      //  1：应收 2:应付
      accountsType: 1,
      // 详情id
      inventoryReconciliationId: null,
      baseInfoList: [
        {name: '账单编号', key: 'billNumber'},
        {name: '生成日期', key: 'createTime'},
        {name: '进出仓结算周期', key: 'settlementCycle'},
        {name: '项目名称', key: 'projectName'},
        {name: '账单状态', key: 'statusVal'},
        {name: '存储结算周期', key: 'storageSettlementCycle'}
      ],
      baseInfoObj: {
        billNumber: '',
        createTime: '',
        settlementCycle: '',
        projectName: '',
        status: '',
        storageSettlementCycle: '',
        statusVal: '',
      },
      tableTitle: [
        {prop: 'subjectName', label: '明细' },
        {prop: 'billHeadName', label: '抬头名称/抬头编码' },
        {prop: 'agentBusinessVal', label: '代收代付' },
        {prop: 'currencyVal', label: '币制' },
        {prop: 'amount', label: '金额' },
        {prop: 'invoiceId', label: '发票编号' }
      ],
      feeList: [],
      
    }
  },

  created() {
    modifyNetTitle('进出仓应收对账详情')
    this.projectId = Number(this.$route.query.projectId)
    this.projectName = this.$route.query.projectName
    this.inventoryReconciliationId = Number(this.$route.query.inventoryReconciliationId)
    this.billIds = [this.inventoryReconciliationId]
    this.initInventoryReconciliationDetails()
  },

  methods: {
    initInventoryReconciliationDetails() {
      InventoryReconciliation.getInventoryReconciliationDetails(this.inventoryReconciliationId).then(res => {
        if (res.success) {
          let { bill, importsBill, exportsBill, rentBill, importsFee, exportsFee, rentFee } = res.result
          let { billNumber, status, createTime, projectName, currency,
            rentBalanceMonth, balanceBeginDate, balanceEndDate
           } = bill
          let baseInfoObj = {
            billNumber,
            createTime: createTime? formatTimeToDate(createTime): '',
            settlementCycle: `${balanceBeginDate}至${balanceEndDate}`,
            projectName,
            status: status,
            statusVal: status === 10?'已结算':'',
            storageSettlementCycle: rentBalanceMonth,
          }
          this.baseInfoObj = baseInfoObj
          let importsFeeArr = this.commonFncFee(currency, importsFee)
          let exportsFeeArr = this.commonFncFee(currency, exportsFee)
          let rentFeeArr = this.commonFncFee(currency, rentFee)
          let feeList = [
            { key: 'enter', name: '进仓费用', currencySystem: importsFeeArr },
            { key: 'exit', name: '出仓费用', currencySystem: exportsFeeArr },
            { key: 'storage', name: '存储费用', currencySystem: rentFeeArr }
          ]
          this.feeList = feeList

          this.enterWarehouseCodeList = this.commonFncEnterOrExitWarehouseList(importsBill)
          let arr = []
          exportsBill.map(i => {
            let obj = {}
            obj.code = i.orderNo
            obj.outboundOrderNo = i.outboundOrderNo
            obj.subjectList = []
            i.feeList.map(j => {
              let obj2 = {}
              obj2.id = j.id;
              obj2.keyword = j.keyword;
              obj2.billId = j.billId;
              obj2.keyId = `${i.orderNo}-${i.outboundOrderNo}-${j.keyword}`;
              obj2.isMod = false;
              obj2.subjectName = j.feeName;
              obj2.isSplit = j.isSplit;
              obj2.agentBusiness = j.agentBusiness ? j.agentBusiness:false;
              obj2.agentBusinessVal = j.agentBusiness ? '是' : '否';
              obj2.billHeadId = j.billHeadId;
              obj2.billHeadName = j.billHead? `${j.billHead.name} ${j.billHead.code}`:'';
              obj2.invoiceId = j.invoiceId;
              obj2.currency = j.currency;
              obj2.currencyVal = this.currencySystemObj[j.currency];
              obj2.isAddService = j.isAddService;
              obj2.amount = j.price;
              obj2.amountCopy = j.price;
              obj.subjectList.push(obj2)
            })
            arr.push(obj)
          })
          this.exitWarehouseCodeList = arr

          let storageCodeList = [];
          rentBill.map(value => {
            let obj = {};
            let obj2 = {}
            obj.code = value.inboundOrderNo;
            obj.id = value.id;
            obj.billId = value.billId;
            obj.totalCharge = value.price;
            
            obj2.id = value.id;
            obj2.settlementDate = `${value.settlementPeriodStart}至${value.settlementPeriodEnd}`;
            obj2.agentBusiness = value.agentBusiness ? value.agentBusiness : false;
            obj2.agentBusinessVal = value.agentBusiness ? '是' : '否';
            obj2.billHeadId = value.billHeadId;
            obj2.billHeadName = value.billHead? `${value.billHead.name} ${value.billHead.code}`:'';
            obj2.currency = value.currency;
            obj2.currencyVal = this.currencySystemObj[value.currency];
            obj2.invoiceId = value.invoiceId;
            obj2.keyId = `${value.inboundOrderNo}`;
            obj2.isMod = false;
            obj2.amount = value.price;
            obj2.amountCopy = value.price;
            obj.subjectList = []
            
            obj.subjectList.push(obj2)
            // value.stockBatch.stockDailyListOfOneMonth.map(j => {
            //   let obj2 = {}
            //   obj2.id = j.id;
            //   obj2.projectId = j.projectId;
            //   obj2.keyId = `${value.inboundOrderNo}-${j.id}`;
            //   obj2.isMod = false;
            //   obj2.settlementDate = j.calculateDate;
            //   obj2.agentBusiness = value.agentBusiness ? value.agentBusiness : false;
            //   obj2.agentBusinessVal = value.agentBusiness ? '是' : '否';
            //   obj2.billHeadId = value.billHeadId;
            //   obj2.billHeadName = value.billHead? `${value.billHead.name} ${value.billHead.code}`:'';
            //   obj2.currency = value.currency;
            //   obj2.currencyVal = this.currencySystemObj[value.currency];
            //   obj2.amount = j.charge;
            //   obj2.amountCopy = j.charge;
            //   obj2.status = j.status;
            //   obj2.invoiceId = j.invoiceId;
            //   obj.subjectList.push(obj2)
            // })
            storageCodeList.push(obj);
          });
          this.storageCodeList = storageCodeList

          if (this.enterWarehouseCodeList.length) {
            let row = this.enterWarehouseCodeList[0]
            this.activeEnterWarehouseCode = row.code
            this.enterWarehouseTableData = row.subjectList
          }
          if (this.exitWarehouseCodeList.length) {
            let row = this.exitWarehouseCodeList[0]
            this.activeExitWarehouseCode = row.code
            this.exitWarehouseTableData = row.subjectList
            this.outboundOrderNo = row.outboundOrderNo
          }
          if (this.storageCodeList.length) {
            let row = this.storageCodeList[0]
            this.activeStorageCode = row.code
            this.storageTableData = row.subjectList
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    
    /**
     * @description 进/出仓和存储币值金额公共方法处理集合
     * @param {*} 对象
    */
    commonFncFee(currency, amount) {
      let arr = []
      arr.push({
        name: currency,
        amount: amount
      })
      return arr
    },

    /** 
     * @description 进/出仓公共方法处理集合
     * @param {*} enterOrExitWarehouseObj 进/出仓对象
    */
    commonFncEnterOrExitWarehouseList(enterOrExitWarehouseObj) {
      let arr = []
      Object.keys(enterOrExitWarehouseObj).forEach(key => {
        let value = enterOrExitWarehouseObj[key]
        let obj = {};
        obj.code = key;
        obj.subjectList = []
        value.map(j => {
          let obj2 = {}
          obj2.id = j.id;
          obj2.keyword = j.keyword;
          obj2.billId = j.billId;
          obj2.keyId = `${key}-${j.keyword}`;
          obj2.isMod = false;
          obj2.agentBusiness = j.agentBusiness ? j.agentBusiness : false;
          obj2.agentBusinessVal = j.agentBusiness ? '是' : '否';
          obj2.billHeadId = j.billHeadId;
          obj2.billHeadName = j.billHead? `${j.billHead.name} ${j.billHead.code}`:'';
          obj2.currency = j.currency;
          obj2.currencyVal = this.currencySystemObj[j.currency];
          obj2.isSplit = j.isSplit;
          obj2.subjectName = j.feeName;
          obj2.isAddService = j.isAddService;
          obj2.amount = j.price;
          obj2.amountCopy = j.price;
          obj2.invoiceId = j.invoiceId;
          obj.subjectList.push(obj2)
        })
        arr.push(obj);
      })
      return arr
    },

    goBack() {
      this.$router.push({
        path: '/finance/inventory-reconciliation/inventory-reconciliation-list',
      })
    },
    
    // 作废
    nullify() {
      this.$confirm("是否确定永久作废该账单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        InventoryReconciliation.postNullify(this.inventoryReconciliationId).then(res => {
          if (res.success) {
            this.goBack()
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    inputNums(row, v) {
      row.amount = getDecimal(v)
    },

    
  }
}
</script>

<style lang='scss'>
.inventory-reconciliation-details {
  .row {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 20px;
    .sub-title {
      height: 52px;
      line-height: 52px;
      border-bottom: 1px solid #eee;
      padding-left: 32px;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
    }
    
  }
  .inventory-reconciliation-details-content {
    background: #fff;
    border-radius: 8px;
    padding: 10px 32px;
    .table-row {
      margin-bottom: 10px;
      .title-row {
        height: 32px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .sub-table-title {
          height: 22px;
          font-size: 16px;
          color: #333333;
          line-height: 28px;
        }
      }
  
      .code-data {
        height: 240px;
        margin-top: 8px;
        display: flex;
        justify-content: flex-start;
        .code-data-left {
          width: 220px;
          height: 100%;
          padding: 10px;
          margin-right: 8px;
          background: #FFFFFF;
          border-radius: 4px;
          border: 1px solid #EEEEEE;
          box-sizing: border-box;
          overflow-y: auto;
          .code-main {
            width: 100%;
            height: 32px;
            padding: 0px 8px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            box-sizing: border-box;
            .tips {
              flex: 1;
              color: #666666;
              font-size: 14px;
              cursor: pointer;
            }
            .tips-active {
              color: #2E68EA;
            }
          }
          .exit-code-main {
            .order-number {
              margin-right: 4px;
            }
          }
          .code-main-active {
            background: #F6F9FF;
          }
          &::-webkit-scrollbar {
            /*滚动条整体样式*/
            width : 4px;  /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
          }
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 2px;
            box-shadow: inset 0 0 5px #D3D3D3;
            background: #DCDCDC;
          }
        }
        .code-data-right {
          flex: 1;
          overflow-y: auto;
          .outbound-order {
            font-size: 16px;
            color: #666666;
            margin-bottom: 8px;
          }
          .w180 {
            width: 180px;
            .el-input__inner {
              height: 30px;
              line-height: 30px;
            }
          }
          .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
            display: flex;
            align-items: center;
            height: 40px;
            line-height: 40px;
          }
          &::-webkit-scrollbar {
            /*滚动条整体样式*/
            width : 4px;  /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
          }
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 2px;
            box-shadow: inset 0 0 5px #D3D3D3;
            background: #DCDCDC;
          }
          .btn-text.is-disabled {
            color: #ccc;
          }
        }
      }
    }
    
    .footer {
      height: 66px;
      display: flex;
      align-items: center;
      justify-content: center;
      .btn-red {
        background-color: #F56C6C;
        color: white;
        border-color: #F56C6C;
      }
    }
  }
}
</style>
